import { defineStore } from 'pinia'
import { reactive, ref } from 'vue'

export const useSpinStore = defineStore('SpinStore', {
    state: () => {
        const step = 1, defaultSpinner = process.env.MIX_DEFAULT_SPINNER; // wordai, spinbot, spinrewriter;
        var maxRange = null;
        if (defaultSpinner == 'wordai') {
            maxRange = 2;
        }
        else if (defaultSpinner == 'spinbot') {
            maxRange = 4;
        }
        else {
            maxRange = 1;
        }
        return {
            defaultSpinner,
            maxCharaterAllowed: ref(500000),
            separatorList: ['null', '||||', 'separator'],
            sliderOptions: {
                start: 0,
                // behaviour: 'drag',
                step: step,
                tooltips: true,
                range: {
                    min: 0,
                    max: maxRange
                },
                format: {
                    to: function (value) {
                        if (defaultSpinner == 'wordai') {
                            return value + 1;
                        }
                        else if (defaultSpinner == 'spinbot') {
                            return parseInt(value * 25);
                        }
                        else {
                            return value + 1;
                        }
                    },
                    from: function (value) {
                        return value;
                    }
                },
                pips: {
                    mode: 'steps',
                    stepped: true,
                    density: 5,
                    format: {
                        to: function (value) {
                            if (defaultSpinner == 'wordai') {
                                return ["minor", "medium", "maximum"][parseInt(value)];
                            }
                            else if (defaultSpinner == 'spinbot') {
                                return ["minor", "moderate","medium", "peak", "maximum"][parseInt(value/step)];
                            }
                            else {
                                return ["Unique", "More Unique"][parseInt(value)];
                            }
                        },
                        from: function (value) {
                            return value;
                        }
                    }
                },
                direction: 'ltr'
            }
        }
    },
    actions: {
        isValidCountCharater(tinymceSelector, contentSelector) {
            let charaterCount = 0;
            tinymce.get(tinymceSelector).dom.select(contentSelector).forEach((element) => {
                charaterCount += element.innerHTML.length;
            });
            return charaterCount <= this.maxCharaterAllowed;
        },
        getSeparator(tinymceSelector, contentSelector) {
            let content = '',
                selectedSeparator = _.head(this.separatorList);
            tinymce.get(tinymceSelector).dom.select(contentSelector).forEach((element) => {
                content += element.innerHTML;
            });
            _.forEach(this.separatorList, function(separator) {
                if(!content.toLowerCase().includes(separator)) {
                    selectedSeparator = separator;
                    return false;
                }  
            });
            return selectedSeparator;
        },
        getContent(tinymceSelector, contentSelector) {
            let content = '',
                editor = tinymce.get(tinymceSelector).dom.select(contentSelector),
                selectedSeparator = this.getSeparator(tinymceSelector, contentSelector);
            editor.forEach((element, index) => {
                content += element.innerHTML;
                if (index < (editor.length - 1)) {
                    content += selectedSeparator;
                }
            });
            return content;
        }
    },
})